import axios from 'axios';
import { recoverGuestApiAuthFailure } from './utils/guestAuthRedirect';

export const API_BASE =
  process.env.REACT_APP_API_BASE ||
  'https://asia-southeast1-catalinx.cloudfunctions.net/weddingFunctions';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    recoverGuestApiAuthFailure(error);
    return Promise.reject(error);
  }
);

export default api;
